/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, total: NonNullable<unknown> }} Sl_Pagination_PageInputs */

const vi_sl_pagination_page = /** @type {(inputs: Sl_Pagination_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trang ${i?.page} / ${i?.total}`)
};

/**

* @param {Sl_Pagination_PageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_pagination_page = /** @type {((inputs: Sl_Pagination_PageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Pagination_PageInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_pagination_page(inputs)
});